import { render, staticRenderFns } from "./CardProfileInformation.vue?vue&type=template&id=71a43308"
import script from "./CardProfileInformation.vue?vue&type=script&lang=js"
export * from "./CardProfileInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports